import TWEEN from '@tweenjs/tween.js';

const Jt = {};

const hasOwnProperty = Object.prototype.hasOwnProperty;

Jt.base = {
    isObject(o) {
        return o && (o.constructor === Object || Object.prototype.toString.call(o) === "[object Object]");
    },
    isArray(o) {
        return o && (o.constructor === Array || Object.prototype.toString.call(o) === "[object Array]");
    },
    isEmpty(o) {
        if(this.isArray(o) && o.length) {
            return false;
        } else if(this.isObject(o)) {
            for(let key in o) {
                if(hasOwnProperty.call(o, key)) {
                    return false;
                }
            }
            return true;
        } else if(o) {
            return false;
        }
        return true;
    },
    parseQueryString(url) {
        var str = url.split("?")[1];
        if (!str) return {};
        var items = str.split("&");
        var result = {};
        var arr;
        for (var i = 0; i < items.length; i++) {
            arr = items[i].split("=");
            result[arr[0]] = arr[1];
        }
        return result;
    },
    getLocalData(data, isRemoveFlag = false) {
        if (typeof data == 'string') {
            const value = window.localStorage.getItem(data);
            isRemoveFlag && delLocalData(data)
            return value;
        } else {
            let localData = {};
            data.map((item, index) => {
                localData[item] = window.localStorage.getItem(item);
                isRemoveFlag && delLocalData(item)
            });
            return localData;
        }
    },
    setLocalData(data, value) {
        if (typeof data == 'string' && (typeof value == 'string' || typeof value == 'number')) {
            window.localStorage.setItem(data, value);
            return;
        }
        if (Jt.base.isObject(data) && !Jt.base.isEmpty(data)) {
            for (let setKey in data) {
                window.localStorage.setItem(setKey, data[setKey]);
            }
            return;
        }
    },
    getUrlParam(paramKey) {
        //获取地址参数值
        var search = decodeURIComponent(location.search), val, params;
        if (search && search.length > 1) {
            search = search.slice(1);
            params = search.split('&');
            for (var i = 0; i < params.length; i++) {
                var param = params[i];
                if (param.split('=').length && String(param.split('=')[0]) === String(paramKey)) {
                    val = String(param.split('=')[1]) == 'undefined' ? '' : String(param.split('=')[1]);
                    break;
                }
            }
        }
        return val ? decodeURIComponent(val) : '';
    }
};

Jt.array = {
    difference(arr1, arr2) {
        const res = [];
        for(let i = 0, len = arr1.length; i < len; i++) {
            if(arr2.indexOf(arr1[i]) === -1) {
                res.push(arr1[i]);
            }
        }
        return res;
    }
};

Jt.dom = (function() {

    function getStyle(el, attr) {
        if(typeof window.getComputedStyle !== 'undefined') {
            return window.getComputedStyle(el, null)[attr]
        } else if(typeof Element.currentStyle !== 'undefined') {
            return el.currentStyle[attr]
        }
    }

    function attr(el, attr, val) {
        if(typeof attr === 'object') {
            for(let i in attr) {
                el.setAttribute(i, attr[i])
            }
        } else {
            if(arguments.length === 2) {
                return el.getAttribute(attr)
            }
            el.setAttribute(attr, val)
        }
    }

    function css(el, attr, val) {
        if(typeof attr === 'object') {
            for(let i in attr) {
                el.style[i] = attr[i]
            }
        } else {
            if(arguments.length === 2) {
                return getStyle(el, attr)
            }
            el.style[attr] = val
        }
    }

    function hasClass(el, className) {
        if(!el || !className) {
            return false
        }
        return el.classList.contains(className)
    }

    function addClass(el, className) {
        if(!el || !className || hasClass(el, className)) {
            return;
        }
        el.classList.add(className)
    }

    function removeClass(el, className) {
        if(!el || !className || !hasClass(el, className)) {
            return
        }
        el.classList.remove(className)
    }

    function toggleClass(el, className) {
        if(hasClass(el, className)) {
            removeClass(el, className);
        } else {
            addClass(el, className);
        }
    }

    function offset(el) {
        if(!el || el.nodeType !== 1) {
            return {top: 0, left: 0};
        }
        const rect = el.getBoundingClientRect();
        const win = el.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    }

    function getScrollPos(el) {
        if(el) {
            return {
                x: el.scrollLeft,
                y: el.scrollTop
            };
        } else {
            return {
                x: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
                y: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
            }
        }
    }

    function setDocTitle(title) {
        if(!title) {
            return;
        }
        document.title = title;
        // const iframe = document.createElement('iframe');
        // iframe.src = require('common/image/logo_48.png');
        // iframe.style.display = 'none';
        // iframe.onload = function() {
        //     setTimeout(function() {
        //         iframe.remove();
        //     });
        // }
        // document.body.appendChild(iframe);
    }

    function scrollTo(params = {}) {
        const pos = getScrollPos(params.el);
        params.x = params.x || pos.x;
        params.y = params.y || pos.y;
        const duration = params.duration || 300;
        const sourcePos = {...pos};
        const targetPos = {x: params.x, y: params.y};
        function init() {
            const tween = new TWEEN.Tween(sourcePos)
                .to(targetPos, duration)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate((obj) => {
                    if(params.el) {
                        el.scrollLeft = obj.x;
                        el.scrollTop = obj.y;
                    } else {
                        window.scrollTo(obj.x, obj.y);
                    }
                });
            tween.start();
        }

        function animate() {
            const id = requestAnimationFrame(animate);
            const result = TWEEN.update();
            if(!result) {
                cancelAnimationFrame(id);
            }
        }
        init();
        animate();
    }

    return {
        attr,
        css,
        hasClass,
        addClass,
        removeClass,
        toggleClass,
        offset,
        getScrollPos,
        setDocTitle,
        scrollTo
    }
})();

Jt.file = {
    formatSize(size, pointLength, units) {
        let unit;
        units = units || [ 'B', 'K', 'M', 'G', 'TB' ];
        while ((unit = units.shift()) && size > 1024) {
            size = size / 1024;
        }
        return (unit === 'B' ? size : size.toFixed( pointLength || 2 )) + unit;
    }
};

Jt.loader = {
    removeExistFiles(tag, urls) {
        const files = document.getElementsByTagName(tag);
        const type = tag === 'script' ? 'src' : 'href';
        const paths = [];
        for(let i = 0, len = files.length; i < len; i++) {
            paths.push(files[i].getAttribute(type));
        }
        return Jt.array.difference(urls, paths);
    },
    loadScripts(scripts, callback, parent = 'body') {
        scripts = Jt.loader.removeExistFiles('script', scripts);
        if(scripts.length === 0) {
            callback && callback();
            return;
        }
        parent = document.getElementsByTagName(parent)[0] || document.documentElement;
        let loaded = 0;
        for(let i = 0, len = scripts.length; i < len; i++) {
            var timer = null;
            let node = document.createElement('script');
            node.onload = node.onreadystatechange = function() {
                window.clearTimeout(timer);
                const rs = this.readyState;
                if('undefined' === typeof rs || 'loaded' === rs || 'complete' === rs) {
                    loaded++;
                    this.onload = this.onreadystatechange = null;
                    node = null;
                    if(loaded === scripts.length) {
                        callback && callback();
                    }
                }
            }
            node.src = scripts[i];
            window.clearTimeout(timer);
            timer = setTimeout(() => {
                node.src = '';
            }, 3000);
            parent.appendChild(node);
        }
    }
};
export default Jt;



// WEBPACK FOOTER //
// ./src/common/util/jt.js